<template>
	<ul>
		<li>
			Documents must be in a {{ acceptParagraph }} format. 
		</li>
		<li>
			We convert all uploaded files to .pdf format 
		</li>
		<li>
			<strong>Limit:</strong> 5 documents each under 30MB 
		</li>
	</ul>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters([`acceptParagraph`]),
	},
};
</script>